import React, { useEffect } from 'react';
import { useHolidayTheme } from '@/hooks/useHolidayTheme';
import { NewYearFireworks } from './NewYearFireworks';
import { NewYearConfetti } from './NewYearConfetti';

interface NewYearThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Applies New Year theme styling and effects when the event is active
 * (database seasonal event or Dec 26–Jan 2 calendar window).
 */
export const NewYearThemeProvider: React.FC<NewYearThemeProviderProps> = ({ children }) => {
  const { isNewYear, isEventActive, showFireworkEffects, showConfettiEffects } = useHolidayTheme();
  const fireworks = isNewYear && (!isEventActive || showFireworkEffects);
  const confetti = isNewYear && (!isEventActive || showConfettiEffects);

  useEffect(() => {
    if (isNewYear) {
      document.body.classList.add('new-year-theme');
      document.documentElement.style.setProperty('--seasonal-accent', '45 93% 47%');
      document.documentElement.style.setProperty('--seasonal-glow', '45 93% 47% / 0.3');
    } else {
      document.body.classList.remove('new-year-theme');
      document.documentElement.style.removeProperty('--seasonal-accent');
      document.documentElement.style.removeProperty('--seasonal-glow');
    }

    return () => {
      document.body.classList.remove('new-year-theme');
      document.documentElement.style.removeProperty('--seasonal-accent');
      document.documentElement.style.removeProperty('--seasonal-glow');
    };
  }, [isNewYear]);

  return (
    <>
      {isNewYear && fireworks && <NewYearFireworks />}
      {isNewYear && confetti && <NewYearConfetti />}
      {children}
    </>
  );
};

export default NewYearThemeProvider;
